/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Picture from '@nmx/template/dist/componentLibrary/components/Picture';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// images
import HandDrawnDownArrowSvg from './images/hand-drawn-down-arrow.svg';
import HandDrawnUpArrowSvg from './images/hand-drawn-up-arrow.svg';

export const ColStyledAppStoreBadgeContainer = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    const smallToMedium = theme.smallToMedium();
    return css`
      position: relative;
      display: flex;
      padding-right: ${mediumUp ? rem(10) : 0};
      justify-content:  ${mediumUp ? 'flex-end' : 'center'};
      ::before {
        display: ${smallToMedium ? 'block' : 'none'};
        content: '';
        background-image: ${`url(${HandDrawnDownArrowSvg.toString()})`};
        position: absolute;
        right: 0;
        left: -13%;
        top: ${rem(-72)};
        height: ${rem(62)};
        width: ${rem(70)};
        background-size: 100%;
        background-repeat: no-repeat;
        margin-left: auto;
        margin-right: auto;
        @media print {
          display: none;
        }
      }
    `;
  }}
`;

export const ColStyledGooglePlayStoreBadgeContainer = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      display: flex;
      padding-left: 0;
      justify-content:  ${mediumUp ? 'flex-start' : 'center'};
    `;
  }}
`;

export const ColStyledPhoneContainer = styled(Col)`
  display: flex;
  align-self: center;
`;

export const ColStyled = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    const smallUp = theme.smallUp();
    let thisPaddingLeft = 0;

    if(mediumUp){
      thisPaddingLeft = rem(35);
    }else if(smallUp){
      thisPaddingLeft = rem(15);
    }

    return css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: ${thisPaddingLeft};
      position: relative;
      margin-bottom: ${smallUp ? 0 : rem(20)};
    `;
  }}
`;

// DOWNLOAD BADGES /////////////////////////////////////////////////////////////
const getBadgeHeight = ({ theme }) => {
  const mediumUp = theme.mediumUp();
  return css`
    height: ${mediumUp ? rem(50) : rem(40)};
  `;
};

export const ImgStyledAppleDownloadBadge = styled.img`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    const thisWidth = mediumUp ? 'auto' : rem(119);
    return css`
      ${getBadgeHeight};
      width: ${thisWidth};
      min-width: ${thisWidth};
    `;
  }}
`;

export const ImgStyledGooglePlayBadge = styled.img`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    const thisWidth = mediumUp ? 'auto' : rem(135);
    return css`
      ${getBadgeHeight};
      width: ${thisWidth};
      min-width: ${thisWidth};
    `;
  }}
`;

// //////////////////////////////////////////////////////////////////////////////
// Is not rendered for mobile devices
export const PictureStyledQrCode = styled(Picture)`
  align-self: center;
  width: ${rem(170)};
  height: auto;
  position: relative;
  padding-bottom: ${rem(20)};
  ::after {
    content: '';
    background-image: ${`url(${HandDrawnUpArrowSvg.toString()})`};
    position: absolute;
    right: -38%;
    bottom: 0;
    width: ${rem(55)};
    height: ${rem(75)};
    background-size: 100%;
    background-repeat: no-repeat;
    @media print {
      display: none;
    }
  }
`;

export const PictureStyledPhone = styled(Picture)`
  ${({ theme }) => {
    const smallUp = theme.smallUp();
    return css`
      align-self: center;
      max-width: ${smallUp ? 'unset' : rem(230)};
      @media print {
        display: none;
      }
    `;
  }}
`;

export const RowStyled = styled(Row)`
  ${({ theme }) => {
    const smallUp = theme.smallUp();
    return css`
      ${!smallUp && 'flex-direction: column-reverse;'};
    `;
  }}
`;

export const SectionContainerStyled = styled(SectionContainer)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding-top: ${mediumUp ? 0 : rem(12)};
    `;
  }}
`;

export const TypographyStyled = styled(Typography)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding-bottom: ${mediumUp ? 0 : rem(24)};
    `;
  }}
`;
